/**
 * @name InstructorCourseService
 * @description Servicio para instructor de cursos (usuario interno/externo)
 * @author Ricardo Guerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Academy Endpoint
const BASE_URL = Environment.getCurrent().endpoints.academy;

/**
 * Consulta el número de cursos para los que es instructor un usuario interno/externo
 * Consultable por cualquier usuario con acceso a Talentry
 */
const get = () => {
  let URL = `${BASE_URL}/Calendarizacion/Impartida`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

export const InstructorCourseService = {
  get
};